
// 后台接口地址
const base_url = 'https://api.ikey-medical.com';
// const base_url = 'http://t-api.bototec.com'
// const base_url = 'http://xaryfp.natappfree.cc';//读本地服务器
// const base_url = 'http://tree.nat300.top';//读本地服务器

const imgUrlPrefix = 'https://ikey-cms-oss.oss-cn-beijing.aliyuncs.com/';

const redirect_uri  = '';


export {
  base_url,
  imgUrlPrefix

}
